/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewPasswordComposition
 */
export interface CRSFSecReviewPasswordComposition {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordComposition
     */
    all: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordComposition
     */
    letters_numbers: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordComposition
     */
    letters_only: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewPasswordComposition
     */
    numbers_only: number;
}

/**
 * Check if a given object implements the CRSFSecReviewPasswordComposition interface.
 */
export function instanceOfCRSFSecReviewPasswordComposition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "all" in value;
    isInstance = isInstance && "letters_numbers" in value;
    isInstance = isInstance && "letters_only" in value;
    isInstance = isInstance && "numbers_only" in value;

    return isInstance;
}

export function CRSFSecReviewPasswordCompositionFromJSON(json: any): CRSFSecReviewPasswordComposition {
    return CRSFSecReviewPasswordCompositionFromJSONTyped(json, false);
}

export function CRSFSecReviewPasswordCompositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPasswordComposition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all': json['all'],
        'letters_numbers': json['letters_numbers'],
        'letters_only': json['letters_only'],
        'numbers_only': json['numbers_only'],
    };
}

export function CRSFSecReviewPasswordCompositionToJSON(value?: CRSFSecReviewPasswordComposition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all': value.all,
        'letters_numbers': value.letters_numbers,
        'letters_only': value.letters_only,
        'numbers_only': value.numbers_only,
    };
}

